import type { Reducer } from 'react'

import type { Option } from '../Content'
import { getInitialValue } from './getInitialValue'
import type { Action, State } from './index'

export const getInitialState = (options: Option[]): State => ({
  value: getInitialValue(options),
})

export const reducer: Reducer<State, Action> = (state, action) => {
  if (action.type === 'toggleApp') {
    return {
      ...state,
      value: {
        ...state.value,
        [action.optionKey]: !state.value[action.optionKey],
      },
    }
  }
  return state as typeof action
}
